import { Observable } from 'rxjs';
import { NavbarHeaderMenuItem, NavbarMenuItem } from './menu-items.models';

export abstract class MenuItemsService {
  abstract getMenuItems(): Observable<NavbarMenuItem[]>;

  abstract getHeaderMenuItems(): Observable<NavbarHeaderMenuItem[]>;

  abstract initializeMenuService(): void;

  abstract onDestroy(): void;
}
